import { PHONE_NUMBER_REGEX } from "../../../../../../helpers/regex";

const validatePhoneNumber = (phNo) => {
  if (!phNo) return "Required";
  if (!PHONE_NUMBER_REGEX.test(phNo)) return "Enter valid phone number";
  return "";
};

export default validatePhoneNumber;
